import Splide from "@splidejs/splide";
import lightGallery from 'lightgallery'; 
import lgThumbnail from 'lightgallery/plugins/thumbnail'
import lgVideo from 'lightgallery/plugins/video'
    
function makeProgramSlider() {
    let splide = new Splide("#program-slider", {
        mediaQuery: "min",
        height: 293,
        arrows: true,
        pagination: false,
        breakpoints: {
            768: {
                height: 700
            },
            1200: {
                height: 962
            },
            1920: {
                height: 1279
            }
        }
    });
    
    splide.mount();
}

let gallery;
let dynamicEl = [];
let options = {
    plugins: [lgVideo, lgThumbnail],
    download: false,
    dynamic: true,
    showCloseIcon: true,
    dynamicEl: dynamicEl,
    thumbnail: true,
    toggleThumb: true,
    allowMediaOverlap: true,
    mobileSettings: {showCloseIcon: true}
};
function launchGallery() {
    
    document.querySelectorAll('.open-gallery').forEach(function(btn) {
        btn.addEventListener('click', function(e) {
            dynamicEl = [];
            switch (btn.dataset.type) {
                case 'videos':   
                    dynamicEl.push({
                        src: btn.dataset.url
                    });
                    
                    break;
                    
                case 'visuels':
                    document.querySelectorAll('#program-slider .splide__slide img').forEach(function(img) {
                        dynamicEl.push({
                            src: img.src,
                            thumb: img.src
                        });
                    });
                    break;
            }
            
            options.dynamicEl = dynamicEl;
            gallery = lightGallery(document.getElementById('gallery'),options);
            gallery.openGallery();
            
        })
    })
}
document.addEventListener("DOMContentLoaded", function () {
    makeProgramSlider();
    launchGallery();
    
});